import type { ReactNode } from 'react'

type BuxusDataCardTableProps = {
  children: ReactNode
}

type BuxusDataCardRowProps = {
  label: string
  children: ReactNode
  /** Preserve line breaks and left-align longer values (description, purpose, …). */
  multiline?: boolean
}

/** Mobile `DataCard` table — label left (gray), value right (bold). */
export function BuxusDataCardTable({ children }: BuxusDataCardTableProps) {
  return (
    <table className="buxus-data-card-table">
      <tbody>{children}</tbody>
    </table>
  )
}

export function BuxusDataCardRow({ label, children, multiline = false }: BuxusDataCardRowProps) {
  return (
    <tr>
      <th scope="row">{label}</th>
      <td className={multiline ? 'buxus-data-card-multiline' : undefined}>{children}</td>
    </tr>
  )
}
